import React, { useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import styles from './AdminLayout.module.css';
import { authAPI } from '../../public/auth/api/authApi';

const AdminLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
      // Define o título ao montar o componentefa
      document.title = "Dashboard - Jungle";

      // Verifica se o usuário é owner; caso contrário redireciona para 404
      (async () => {
        try {
          const info = await authAPI.get_client_info();
          if (!info || info.is_owner !== true) {
            navigate('/not-found');
          }
        } catch (err) {
          // acessos não autorizados retornam 404 do backend — tratar como não encontrado
          navigate('/not-found');
        }
      })();

        // Opcional: Volta para o nome padrão ao sair da página (unmount)
        return () => {
          document.title = "Jungle Artigos Militares";
        };
    }, [navigate]);
  return (
    <div className={styles.container}>
      {/* Menu Lateral */}
      <aside className={styles.sidebar}>
        <div className={styles.logo}>PAINEL ADMIN</div>
        <nav className={styles.nav}>
          <NavLink 
            to="/admin/products" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
          >
            📦 Products
          </NavLink>
          <NavLink 
            to="/admin/dashboard" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
          >
            📈 Dashboard
          </NavLink>
          
          {/* Nova Área de Banners Adicionada Aqui */}
          <NavLink 
            to="/admin/banners" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
          >
            🖼️ Banners
          </NavLink>

          <NavLink 
            to="/admin/orders" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
          >
            🛒 Orders
          </NavLink>
          <NavLink 
            to="/admin/categories" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
          >
            🗂️ Categories
          </NavLink>
          <NavLink 
            to="/admin/coupons" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.active}` : styles.navLink}
          >
            🎟️ Coupons
          </NavLink>
        </nav>
      </aside>

      {/* Conteúdo Principal */}
      <main className={styles.main}>
        <header className={styles.header}>
          <div className={styles.headerInfo}>Dashboard / Overview</div>
          <div className={styles.user}>Admin User</div>
        </header>
        
        <div className={styles.content}>
          {/* O Outlet é ESSENCIAL: Ele renderiza o componente da rota filha */}
          <Outlet /> 
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;